import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
  ${componentStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    --p-folder-tree-margin: 0px;
  }

  .folder,
  .folder-inner {
    position: relative;
  }

  /* Reset button styles */
  button {
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: var(--p-text-color);
    text-align: left;
    cursor: pointer;
    font-family: var(--p-font);
  }

  .folder-inner::before {
    content: '';
    display: block;
    position: absolute;
    top: 4px;
    bottom: 4px;
    left: 0;
    width: 4px;
    border-radius: 4px;
    background-color: var(--p-folder-selected-border-color, var(--p-brand));
    visibility: hidden;
    z-index: 1;
  }

  .folder-button {
    font-size: 1rem;
    font-weight: normal;
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    padding-left: 25px;
    border: 1px solid transparent;
    border-radius: var(--p-folder-button-border-radius, 6px);
  }

  .selected .folder-inner .folder-button {
    background-color: var(--p-text-color-contrast-50);
  }

  .folder-inner:hover .folder-button {
    background-color: var(--p-text-color-contrast-100);
  }

  .selected .folder-inner::before {
    visibility: visible;
  }

  .folder-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /**
--------------------------------------------------
* Icon
--------------------------------------------------
*/
  svg {
    display: block;
  }

  .icon {
    margin-right: 5px;
    position: relative;
  }

  .icon.folder-icon {
    margin-right: 3px;
  }

  .expand {
    position: absolute;
    top: 6px;
    left: 2px;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .expand:hover {
    background-color: var(--p-expand-bg-hover, var(--p-bg));
  }

  .selected .expand:hover {
    background-color: var(--p-expand-selected-bg-hover, var(--p-text-color-contrast-100));
  }

  .open .expand svg {
    transform: rotate(90deg);
  }

  /**
--------------------------------------------------
* Sub
--------------------------------------------------
*/
  .sub {
    display: none;
    --mf-folder-tree-margin: 0px;
  }

  .open .sub {
    display: block;
  }
`;
